<template>
    <svg width="13" height="19" viewBox="0 0 13 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1V6C1 7.85801 1 8.78702 1.12312 9.56435C1.80083 13.8433 5.15673 17.1992 9.43565 17.8769C10.213 18 11.142 18 13 18V18" stroke="currentColor" stroke-linecap="round"/>
    </svg>
</template>
